module.exports = __webpack_public_path__ + "img/micropointTopBg2.860968f6.png";